import { api } from './client';
import type {
  JoinRequestDto,
  LeaderboardEntry,
  MemberDto,
  MyRoomsResponse,
  Room,
  RoomInvitation,
  RoomInviteDto,
  UserSummary,
} from './types';

export interface CreateRoomInput {
  name: string;
  emoji?: string;
  description?: string;
  type: 'PRIVATE' | 'PUBLIC';
  maxMembers?: number;
  membersCanInvite?: boolean;
}

export type UpdateRoomInput = Partial<CreateRoomInput>;

export const roomsApi = {
  create: (req: CreateRoomInput) => api.post<Room>('/rooms', req),

  mine: () => api.get<MyRoomsResponse>('/rooms/me'),
  detail: (id: string) => api.get<Room>(`/rooms/${id}`),
  discover: (search = '', limit = 30) =>
    api.get<Room[]>(`/rooms/discover?search=${encodeURIComponent(search)}&limit=${limit}`),

  update: (id: string, req: UpdateRoomInput) => api.patch<Room>(`/rooms/${id}`, req),

  leave: (id: string) => api.post<void>(`/rooms/${id}/leave`),
  removeMember: (id: string, userId: string) => api.delete<void>(`/rooms/${id}/members/${userId}`),

  members: (id: string) => api.get<MemberDto[]>(`/rooms/${id}/members`),
  leaderboard: (id: string) => api.get<LeaderboardEntry[]>(`/rooms/${id}/leaderboard`),

  inviteByEmail: (id: string, email: string) =>
    api.post<RoomInvitation>(`/rooms/${id}/invite`, { email }),
  generateLink: (id: string) => api.post<RoomInvitation>(`/rooms/${id}/invite-link`),

  // In-app invitations (room side)
  listInvites: (roomId: string) => api.get<RoomInviteDto[]>(`/rooms/${roomId}/invites`),
  createInvite: (roomId: string, userId: string) =>
    api.post<RoomInviteDto>(`/rooms/${roomId}/invites`, { userId }),
  cancelInvite: (roomId: string, inviteId: string) =>
    api.delete<void>(`/rooms/${roomId}/invites/${inviteId}`),

  // User search for invite picker
  searchUsers: (nick: string) =>
    api.get<UserSummary[]>(`/users/search?nick=${encodeURIComponent(nick)}`),

  joinRequests: (id: string) => api.get<JoinRequestDto[]>(`/rooms/${id}/join-requests`),
  requestJoin: (id: string) => api.post<JoinRequestDto>(`/rooms/${id}/join-requests`),
  acceptRequest: (id: string, requestId: string) =>
    api.post<void>(`/rooms/${id}/join-requests/${requestId}/accept`),
  rejectRequest: (id: string, requestId: string) =>
    api.post<void>(`/rooms/${id}/join-requests/${requestId}/reject`),
};
